module.exports = __webpack_public_path__ + "img/exclude.0cc65bfc.svg";